// 언어 상수. 순환 import 를 피하려고 다른 모듈을 하나도 끌어오지 않는다
// (LangSlice 와 i18n/index.js 양쪽이 여기만 본다).
export const DEFAULT_LANG = "ko";
export const SUPPORTED_LANGS = ["ko", "en"];
export const LANG_STORAGE_KEY = "tlatfarm:lang";

export const isSupportedLang = (value) => SUPPORTED_LANGS.includes(value);

export const readStoredLang = () => {
  if (typeof window === "undefined") return DEFAULT_LANG;
  try {
    const saved = window.localStorage.getItem(LANG_STORAGE_KEY);
    return isSupportedLang(saved) ? saved : DEFAULT_LANG;
  } catch (error) {
    return DEFAULT_LANG;
  }
};

export const saveStoredLang = (lang) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch (error) {
    // localStorage 를 못 써도 언어 전환 자체는 동작해야 한다.
  }
};
